module.exports = __webpack_public_path__ + "img/ball1.b6442ab8.png";